import './App.css';
import About from './components/About/About';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Skills from './components/Skils/Skills';
import Work from './components/Work/Work';

function App() {
  return (
    <div>
      <Header/>
      <main className='main'>
        <Home/>
        <About/>
        <Skills/>
        <Work/>
      </main>
    </div>
  );
}

export default App;
